import FormFieldTimestamp from "components/FormFields/Timestamp";
import FormFieldViewText from "components/FormFields/ViewText";
import MetaInfoBoolean from "components/MetaInfoList/Boolean";
import SpacePath from "components/SpacePath";
import TagsList from "components/TagsList";
import Box from "ds/components/Box";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import FormField from "ds/components/Form/Field";
import Link from "ds/components/Link";
import Typography from "ds/components/Typography";
import { NamedWebhooksIntegration } from "types/generated";

import styles from "./styles.module.css";

type WebhookDetailsDrawerProps = {
  webhook: NamedWebhooksIntegration;
};

const WebhookDetailsDrawer = createDrawer(({ webhook }: WebhookDetailsDrawerProps) => {
  return (
    <DrawerSimple>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Webhook details" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody>
        <FormFieldViewText label="Name" value={webhook.name} />

        <FormField label="Endpoint URL">
          <Typography tag="span" variant="p-body2">
            <Link href={webhook.endpoint} target="_blank">
              {webhook.endpoint}
            </Link>
          </Typography>
        </FormField>

        <FormField label="Space">
          <SpacePath
            variant="expandable"
            spaceId={webhook.space.id}
            fallbackName={webhook.space.name}
          />
        </FormField>

        <FormField label="Enabled">
          <MetaInfoBoolean
            text={webhook.enabled ? "Enabled" : "Disabled"}
            value={webhook.enabled}
          />
        </FormField>
        <FormField label="Retry on failure">
          <MetaInfoBoolean
            text={webhook.retryOnFailure ? "Enabled" : "Disabled"}
            value={webhook.retryOnFailure}
          />
        </FormField>
        <FormFieldTimestamp timestamp={webhook.createdAt} label="Created at" />
        {webhook.labels.length > 0 && (
          <FormField label="Labels">
            <TagsList tags={webhook.labels} alwaysExpanded />
          </FormField>
        )}
        {!!webhook.secretHeaders.length && (
          <Box direction="column" className={styles.headersWrapper} gap="large">
            <Typography tag="span" variant="p-t5">
              Headers
            </Typography>

            {webhook.secretHeaders.map((key) => (
              <Box __deprecatedGap="1rem" align="center" key={key}>
                <FormField label="Key" className={styles.headerField}>
                  <Typography tag="span" variant="p-body2">
                    {key}
                  </Typography>
                </FormField>
                <FormField label="Value" className={styles.headerField}>
                  <Typography tag="span" variant="p-body2">
                    &bull;&bull;&bull;&bull;&bull;&bull;&bull;
                  </Typography>
                </FormField>
              </Box>
            ))}
          </Box>
        )}
      </DrawerBody>
    </DrawerSimple>
  );
});

export const showWebhookDetailsDrawer = createDrawerTrigger(WebhookDetailsDrawer);
